import { Typography, Box, Container } from "@mui/material";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  return (
    <> 
    <Container maxWidth="lg"> 
     <Typography variant="body1" fontWeight={600} align='left' gutterBottom> Disclosures </Typography>
    {
      location.pathname.includes('connect-with-us') && 
      <> 
      <Typography variant="body2" color="#555" align='left' gutterBottom> By providing us with a telephone number for a cellular phone or other wireless device, including a number that you later convert to a cellular number, you are expressly consenting to receiving communications - including but not limited to prerecorded or artificial voice message calls, text messages, and calls made by an automatic telephone dialing system - from us and our affiliates and agents at that number. This express consent applies to each such telephone number that you provide to us now or in the future and permits such calls for non-marketing purposes. Calls and messages may incur access fees from your cellular provider.</Typography>
      <Typography variant="body2" color="#555" align='left' gutterBottom> By providing your email address, you are consenting to receive marketing messages from U.S. Bank. If you prefer not to receive marketing email from us, you can opt-out of all marketing emails by adjusting your preferences at any time.</Typography>
      </>
    }
    
    <Typography variant="body2" color="#555" align='left' gutterBottom>All trademarks, product names, logos, and brands are property of their respective owners and are used for identification purposes only. Use of these trademarks, names, logos, and brands or the listing of a company on this page does not imply endorsement of the company, or its products or services by U.S. Bank.  Customers should perform their own due diligence on the appropriateness of any company’s products and services for use by the customer.</Typography>
    <Typography variant="body2" color="#555" align='left' gutterBottom>RTP® is a registered trademark of The Clearing House Payments Company L.L.C. Zelle and the Zelle related marks are wholly owned by Early Warning Services, LLC and are used herin under license.</Typography>
    <Typography variant="body2" color="#555" align='left' gutterBottom mb={3}>Deposit products are offered by U.S. Bank National Association. Member FDIC.</Typography>
    </Container>
    <Box bgcolor='primary.darker' py={2}>
        <Container maxWidth="lg" style={{ display: 'flex', justifyContent: 'space-between' }}> 
          {/* Privacy Policy and Copyright in the same row */}
          <Typography variant="body2" color="#fff" align="left">
            <a
              href="https://www.usbank.com/about-us-bank/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              U.S. Bank Privacy Policy
            </a>
          </Typography>
          <Typography variant="body2" color="#fff" align="right">
            © {new Date().getFullYear()} U.S. Bank
          </Typography>
        </Container>
        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}> 
          {/* California Privacy Notice */}
          <Typography variant="body2" color="#fff" align="left">
            <strong style={{fontWeight: '500'}}>RESIDENTS OF CALIFORNIA:</strong> Please see the{' '}
            <a
              href="https://www.usbank.com/about-us-bank/privacy/state-personal-information-program.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              <strong style={{fontWeight: '500'}}>U.S. Bank California Privacy Notice</strong>
            </a>{' '}
            for information on how we collect or use your personal information.
          </Typography>
        </Container>
    </Box>
    </>
  );
};
export default Footer;
